import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import api from "../../../api/axios";
import ReportsTabs from "./ReportsTabs";

export default function MonthlyReport() {
  const [period, setPeriod] = useState("");
  const [loading, setLoading] = useState(false);
  const [summary, setSummary] = useState([]);
  const [usingSample, setUsingSample] = useState(false);

  useEffect(() => {
    // optional: auto-fill current month
    const now = new Date();
    const mm = (now.getMonth() + 1).toString().padStart(2, "0");
    const yyyy = now.getFullYear();
    setPeriod(`${yyyy}-${mm}`);
  }, []);

  const fetchReport = async () => {
    if (!period)
      return Swal.fire("Select Month", "Please select a period", "warning");
    setLoading(true);
    try {
      const res = await api.get(`hrms/prms/reports/summary/${period}`);
      setSummary(res.data.data);
      setUsingSample(false);
    } catch (err) {
      console.warn("report api failed", err);
      // sample data
      setSummary([
        {
          employee: "John Doe",
          employee_code: "EMP001",
          department: "Sales",
          gross: 50000,
          deductions: 5000,
          net: 45000,
        },
      ]);
      setUsingSample(true);
    }
    setLoading(false);
  };

  const downloadExcel = () => {
    if (!summary.length)
      return Swal.fire("No Data", "Generate the report first", "info");
    const ws = XLSX.utils.json_to_sheet(summary);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Monthly Summary");
    const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    saveAs(
      new Blob([wbout], { type: "application/octet-stream" }),
      `monthly_summary_${period}.xlsx`
    );
  };

  const downloadCSV = () => {
    if (!summary.length)
      return Swal.fire("No Data", "Generate the report first", "info");
    const csv = summary
      .map(
        (r) =>
          `${r.employee || ""},${r.employee_code || ""},${r.department || ""},${
            r.gross || 0
          },${r.deductions || 0},${r.net || 0}`
      )
      .join("\n");
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    saveAs(blob, `monthly_summary_${period}.csv`);
  };

  // return (
  //   <div style={{ background: "#eef6fd", minHeight: "100vh" }}>
  //     <div className="container py-4">
  //       <div className="d-flex justify-content-between align-items-center mb-4">
  //         <h3 className="fw-bold">Monthly Payroll Report</h3>
  //         <div className="d-flex gap-2">
  //           <button className="btn btn-outline-secondary" onClick={() => { setPeriod(''); setSummary([]); }}>Reset</button>
  //           <button className="btn btn-primary" onClick={fetchReport} disabled={loading}>{loading ? "Generating..." : "Generate Report"}</button>
  //         </div>
  //       </div>

  //       <div className="bg-white border rounded shadow-sm p-4 mb-3">
  //         <div className="row g-3 align-items-center">
  //           <div className="col-md-4">
  //             <label className="form-label">Period</label>
  //             <input type="month" className="form-control" value={period} onChange={(e) => setPeriod(e.target.value)} />
  //           </div>
  //           <div className="col-md-8 text-end">
  //             <button className="btn btn-sm btn-outline-primary me-2" onClick={downloadCSV}>Download CSV</button>
  //             <button className="btn btn-sm btn-outline-success" onClick={downloadExcel}>Download Excel</button>
  //           </div>
  //         </div>
  //       </div>

  //       <div className="bg-white border rounded shadow-sm p-4">
  //         <h5 className="fw-bold mb-3">Summary</h5>
  //         <div className="table-responsive">
  //           <table className="table table-sm">
  //             <thead>
  //               <tr><th>Employee</th><th>Code</th><th>Department</th><th className="text-end">Gross</th><th className="text-end">Deductions</th><th className="text-end">Net</th></tr>
  //             </thead>
  //             <tbody>
  //               {summary.map((r, idx) => (
  //                 <tr key={idx}>
  //                   <td>{r.employee}</td>
  //                   <td>{r.employee_code}</td>
  //                   <td>{r.department}</td>
  //                   <td className="text-end">₹{Number(r.gross || 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
  //                   <td className="text-end">₹{Number(r.deductions || 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
  //                   <td className="text-end">₹{Number(r.net || 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
  //                 </tr>
  //               ))}
  //               {summary.length === 0 && <tr><td colSpan={6} className="text-center text-muted">No data — generate report</td></tr>}
  //             </tbody>
  //           </table>
  //         </div>
  //       </div>

  //     </div>
  //   </div>
  // );
  return (
    <>
      <ReportsTabs />
    </>
  );
}
